export default {
  /**
   * STORE Configuration
   */
  store: {
    strict: process.env.APP_ENV !== 'production' || false
  },

  /**
   * Services Configuration
   */
  services: {
    /**
     * Finance Service Configuration
     *
     */
    finance: {
      baseURl: `${process.env.VUE_APP_FINANCE_API}`
    },

    /**
     * Main Service Configuration
     *
     */
    main: {
      baseURl: `${process.env.VUE_APP_MAIN_API}`
    },

    /*
     * Authentication Service Configuration

     */
    authentication: {
      baseURl: `${process.env.VUE_APP_AUTH_API}`,
      refreshTime: 60 * 5 // 5 mins
    }
  }
}
